import plugin from 'tailwindcss/plugin';

export default plugin(function ({ addUtilities }) {
  const newUtilities = ['auto', '2']
    .map((value) => {
      return { [`.col-count-${value}`]: { 'column-count': value } };
    })
    .reduce(function (result, item) {
      const key = Object.keys(item)[0];

      result[key] = item[key];

      return result;
    }, {});

  addUtilities(newUtilities, ['responsive']);
});
